module.exports = __webpack_public_path__ + "static/media/lu_logo.29a052a9.png";